import React from "react";
import { SearchResultPlan, Plan } from "../@types";
import { useTranslate } from "../helpers";
import { shouldSuppressPlanBenefits } from "../helpers/planHelpers";

const SuppressionHandler: React.FunctionComponent<{
  plan: SearchResultPlan | Plan;
}> = ({ plan, children }) => {
  const t = useTranslate();
  return (
    <span>
      {shouldSuppressPlanBenefits(plan)
        ? t("suppressed_plan_benefit")
        : children}
    </span>
  );
};

export default SuppressionHandler;
